.input {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 2.4rem;
  border-radius: var(--card-border-radius);
  font-family: Inter, sans-serif;
  font-size: 1.4rem;
  line-height: 1.6rem;
  display: flex;
  z-index: 1;
  align-items: center;
  color: var(--color-grayscale-white);
  background: transparent;
  border: none;
  white-space:nowrap;
  overflow:hidden;
  text-overflow: ellipsis;

  &:hover {
    cursor: text;
  }

  svg {
    width: 12px;
    height: 12px;
  }

  &:focus {
    outline: none;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
